/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type ApiApplicationRequester = {
    id?: string
    type?: ApiApplicationRequester.type
    name?: string
}

export namespace ApiApplicationRequester {
    export enum type {
        HELM = 'helm',
        BREEZE = 'breeze',
        UNKNOWN = 'unknown'
    }
}
